import { LabReport, parseLabReport, PdfPage } from './parseLabReport';

// pdfjs (~1 MB) só carrega na tela de importação. O worker.entry registra o
// worker em window.pdfjsWorker e o pdfjs roda no próprio thread da página:
// evita configurar um arquivo de worker separado no build do CRA 4, e os
// laudos são de 1 a 2 páginas.
async function loadPdfjs() {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf');
  await import('pdfjs-dist/legacy/build/pdf.worker.entry');
  return pdfjs;
}

export async function extractPdfPages(file: File): Promise<PdfPage[]> {
  const pdfjs = await loadPdfjs();
  const data = new Uint8Array(await file.arrayBuffer());
  const document = await pdfjs.getDocument({ data }).promise;
  const pages: PdfPage[] = [];

  try {
    for (let number = 1; number <= document.numPages; number += 1) {
      // eslint-disable-next-line no-await-in-loop
      const page = await document.getPage(number);
      const { width } = page.getViewport({ scale: 1 });
      // eslint-disable-next-line no-await-in-loop
      const content = await page.getTextContent();

      pages.push({
        width,
        items: content.items
          .filter(
            (
              item,
            ): item is typeof item & { str: string; transform: number[] } =>
              'str' in item,
          )
          .map(item => ({
            str: item.str,
            x: item.transform[4],
            y: item.transform[5],
          })),
      });
    }
  } finally {
    document.destroy();
  }

  return pages;
}

export async function readLabReport(file: File): Promise<LabReport> {
  return parseLabReport(await extractPdfPages(file));
}
